/**
 * DiaryShareActions — 日記頁底部動作：〔分享整頁〕＋〔加入播放清單〕
 *
 * 血緣：`decisions/031`（**分享整頁**；公開連結，iOS-safe —— 唔靠檔案分享）
 *   ＋ `decisions/033`（〔加入播放清單〕；產品負責人指定要隔離喺〔分享〕下面）
 * 由 `components/DiaryCard.tsx` 拆出（`P-90`：每個檔 ≤200 行）
 *
 * ⚠️ 分享**只跟揀咗嗰版**（`decisions/036`／2026-09-23#6：分享頁播 `audio_key` ＝ 你揀嗰版）
 * ⚠️ 日記**文字**唔會分享（只分享公開頁）
 */
import { useTranslation } from 'react-i18next';
import SharePageLink from './SharePageLink';

const BTN: React.CSSProperties = {
  minHeight: '36px',
  padding: '0 12px',
  borderRadius: '18px',
  border: '1.5px solid var(--color-divider)',
  background: 'var(--color-card)',
  color: 'var(--color-text)',
  fontFamily: 'inherit',
  fontSize: 'var(--font-size-small, 15px)',
  fontWeight: 700,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

export interface DiaryShareActionsProps {
  songId: string;
  title: string;
  deviceId: string | null;
  /** 多版本時標明「第 N 版 / 共 M 版」；單版 → `undefined` */
  variantLabel?: string;
  onAddPlaylist: () => void;
}

export default function DiaryShareActions({
  songId,
  title,
  deviceId,
  variantLabel,
  onAddPlaylist,
}: DiaryShareActionsProps) {
  const { t } = useTranslation();
  return (
    <div style={{ marginTop: '14px' }}>
      <SharePageLink songId={songId} title={title} deviceId={deviceId ?? ''} text={t('share_page_text')} versionLabel={variantLabel} />
      <button
        type="button"
        data-testid="diary-add-playlist"
        onClick={onAddPlaylist}
        style={{ ...BTN, width: '100%', marginTop: '8px' }}
      >
        {t('playlist_add_button')}
      </button>
    </div>
  );
}
